import { render } from "./Portal.vue?vue&type=template&id=9ab92c8a&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"

import "./Portal.vue?vue&type=style&index=0&id=9ab92c8a&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab92c8a"]])

export default __exports__